import { defaultConfig, ThemingService } from 'atlas-cdk';
import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';


@Component({
  standalone: false,
  selector: 'dsp-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly env = environment;
  public isUserLogged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  public constructor(private readonly title: Title, private readonly _themingService: ThemingService) {
    this._themingService.applyConfigTheming();

    if (this.env.production) {
      this.title.setTitle(`Investor Portal`);
    } else {
      this.title.setTitle(`Investor Portal ${this.env.banner} ${this.env.internal ? 'Admin' : 'Client'} v${this.env.version}`);
    }
  }

}



//   private handleGetUserInfoRequest(): void {
//     this._store
//       .pipe(select(selectUserRequestStatus))
//       .pipe(
//         filter(requestStatus => requestStatus.isFinished),
//         withLatestFrom(this._authService.mssoLoggedIn$, this._store.pipe(select(selectLoginErrorMessage))),
//         take(1),
//       )
//       .subscribe(([requestStatus, mssoLoggedIn, loginErrorMessage]) => {
//         if (!mssoLoggedIn || requestStatus.isFailure) {
//           this._authService.logout();

//           if (loginErrorMessage)
//             this._store.dispatch(new AddErrorToastAction(loginErrorMessage, this._labelsPipe.transform('general_error_title')));
//         } else {
//           this.setSessionAsActive();
//         }
//       });
//   }
// }


